import { render, staticRenderFns } from "./new holidays.vue?vue&type=template&id=c2a978cc"
import script from "./new holidays.vue?vue&type=script&lang=js"
export * from "./new holidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports